import store from "@/store";
import { Account, Loader, Roles } from "@/constants";

export default {
  load() {
    var localization = store.getters.getLocalization;
    var menuItems = [
      {
        id: 'home',
        cy: 'home-menu',
        icon: "mdi-home",
        rules: [],
        subItems: [],
        text: localization ? "Home" : "Hogar",
        to: "/",
        bottom: true,
        menu: true,
        toolbar: false,
      },
      {
        id: "roof",
        cy: 'roof-menu',
        breakpoint: 3,
        icon: "mdi-home-roof",
        rules: [],
        text: localization ? "Roofing" : "Techumbre",
        subItems: [
          {
            id: "roof.home",
            cy: 'roof-home',
            icon: "mdi-home-roof",
            rules: [],
            text: localization ? "Home" : "Hogar",
            subItems: [],
            to: "/roofing/home",
            bottom: true,
            menu: true,
            toolbar: true,
          },
          {
            id: "roof.replace",
            cy: 'roof-replace',
            icon: "mdi-file-replace-outline",
            rules: [],
            text: localization ? "Replacement" : "Reemplazo",
            subItems: [],
            to: "/roofing/replace",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "roof.repair",
            cy: 'roof-repair',
            icon: "mdi-auto-fix",
            rules: [],
            text: localization ? "Repairs" : "Refaccion",
            subItems: [],
            to: "/roofing/repair",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "roof.dam",
            cy: 'roof-dam',
            icon: "mdi-water-alert",
            rules: [],
            text: localization ? "Ice Dams" : "Presas De Hielo",
            subItems: [],
            to: "/roofing/ice",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "roof.sign",
            cy: 'roof-sign',
            icon: "mdi-sign-caution",
            rules: [],
            text: localization ? "Signs" : "Senales",
            subItems: [],
            to: "/roofing/signs",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "roof.choose",
            cy: 'roof-choose',
            icon: "mdi-checkbox-marked-outline",
            rules: [],
            text: localization ? "Choose" : "Elegir",
            subItems: [],
            to: "/roofing/choose",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "roof.faq",
            cy: 'roof-faq',
            icon: "mdi-frequently-asked-questions",
            rules: [],
            text: localization ? "Materials FAQ" : "PFS Materiales",
            subItems: [],
            to: "/roofing/materials",
            bottom: false,
            menu: true,
            toolbar: true,
          },
        ],
        to: "/roofing",
        bottom: false,
        menu: true,
        toolbar: true,
      },
      {
        id: "gutters",
        cy: "gutters",
        breakpoint: 3,
        icon: "mdi-water-outline",
        rules: [],
        text: localization ? "Gutters" : "Canalones",
        bottom: false,
        menu: true,
        toolbar: true,
        to: "/gutters",
        subItems: [
          {
            id: "gutters.home",
            cy: "gutters.home",
            icon: "mdi-water-outline",
            rules: [],
            text: localization ? "Home" : "Hogar",
            subItems: [],
            to: "/gutters",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "gutters.repair",
            cy: "gutters.repair",
            icon: "mdi-auto-fix",
            rules: [],
            text: localization ? "Repair" : "Reparar",
            subItems: [],
            to: "/gutters/repair",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "gutters.replace",
            cy: "gutters-replace",
            icon: "mdi-file-replace-outline",
            rules: [],
            text: localization ? "Replace" : "Reemplazar",
            subItems: [],
            to: "/gutters/replace",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "gutters.protection",
            cy: "gutters-protection",
            rules: [],
            icon: "mdi-shield-sun-outline",
            text: localization ? "Protection" : "Protección",
            subItems: [],
            to: "/gutters/protection",
            bottom: false,
            menu: true,
            toolbar: true,
          }
        ],
      },
      {
        id: "windows",
        cy: "windows",
        icon: "mdi-window-closed-variant",
        breakpoint: 4,
        rules: [],
        text: localization ? "Windows" : "Ventanas",
        to: "/",
        bottom: false,
        menu: true,
        toolbar: true,
        subItems: [
          {
            id: "windows.home",
            cy: "windows.home",
            icon: "mdi-window-closed",
            text: localization ? "Home" : "Hogar",
            rules: [],
            subItems: [],
            to: "/windows/home",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "windows.enegry",
            cy: "windows.enegry",
            icon: "mdi-frequently-asked-questions",
            text: localization ? "Energy Saving" : "Ahorro de energía",
            rules: [],
            subItems: [],
            to: "/windows/energy",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "window.replace",
            cy: "window.replace",
            icon: "mdi-file-replace-outline",
            text: localization ? "Why replace" : "¿Por qué reemplazar?",
            rules: [],
            subItems: [],
            to: "/windows/why",
            bottom: false,
            menu: true,
            toolbar: true,
          },
        ],
      },
      {
        id: "siding",
        cy: "siding",
        icon: "mdi-shield-home-outline",
        breakpoint: 4,
        rules: [],
        text: localization ? "Siding" : "Vía muerta",
        to: "/",
        bottom: false,
        menu: true,
        toolbar: true,
        subItems: [
          {
            id: "siding.home",
            cy: "siding-home",
            icon: "mdi-shield-home-outline",
            rules: [],
            text: localization ? "Siding" : "Vía muerta",
            subItems: [],
            to: "/siding/home",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "siding.options",
            cy: "siding-options",
            icon: "mdi-form-select",
            rules: [],
            text: localization ? "Options" : "Opciones de revestimiento",
            subItems: [],
            to: "/siding/options",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "siding.trim",
            cy: "siding-trim",
            icon: "mdi-package-variant-closed",
            rules: [],
            text: localization ? "Trim Packages" : "Paquetes de equipamiento",
            subItems: [],
            to: "/siding/trim",
            bottom: false,
            menu: true,
            toolbar: true,
          },
        ],
      },
      {
        id: "about",
        cy: "about",
        icon: "mdi-information-outline",
        rules: [],
        text: localization ? "About" : "Sobre nosotros",
        to: "/about/home",
        bottom: false,
        menu: true,
        toolbar: true,
        subItems: [
          {
            id: "about.home",
            cy: "about.home",
            icon: "mdi-information-variant",
            rules: [],
            text: localization ? "About" : "Sobre nosotros",
            subItems: [],
            to: "/about/home",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "about.staff",
            cy: "about.staff",
            icon: "mdi-account-group-outline",
            rules: [],
            text: localization ? "Staff" : "Conozca a nuestro personal",
            subItems: [],
            to: "/about/staff",
            bottom: false,
            menu: true,
            toolbar: true,
          },
          {
            id: "about.license",
            cy: "about.license",
            icon: "mdi-shield-car",
            rules: [],
            text: localization ? "License & Insurance" : "Licencia y Seguro",
            subItems: [],
            to: "/about/insurance",
            bottom: false,
            menu: true,
            toolbar: true,
          },
        ],
      },
      {
        id: "account",
        cy: "account-menu",
        breakpoint: 5,
        icon: "mdi-account",
        rules: [],
        subItems: [
          {
            id: "login",
            cy: "account-login-menu",
            icon: "mdi-login",
            rules: [ Account.loggedOut ],
            text: localization ? "Login" : "Accesco",
            to: "/account/login",
            bottom: false,
            menu: true,
            toolbar: false,
              },
          {
            id: "logout",
            cy: "account-logout-menu",
            icon: "mdi-logout",
            rules: [ Account.loggedIn ],
            text: localization ? "Logout" : "Logotipo",
            to: "/account/logout",
            bottom: false,
            menu: true,
            toolbar: false,
              },
          {
            id: "register",
            cy: "account-register-menu",
            icon: "mdi-account-plus-outline",
            rules: [ Account.loggedOut ],
            text: localization ? "Register" : "Registro",
            to: "/account/register",
            bottom: false,
            menu: true,
            toolbar: false,
          },
          {
            id: "reset",
            cy: "account-reset-menu",
            icon: "mdi-lock-reset",
            rules: [ Account.loggedOut ],
            text: localization ? "Reset Password" : "Restablecer contraseña",
            to: "/account/reset2",
            bottom: false,
            menu: true,
            toolbar: false,
          },
          {
            id: "forgot",
            cy: "account-forgot-menu",
            icon: "mdi-account-question-outline",
            rules: [ Account.loggedOut ],
            text: localization ? "Forgot Username" : "Olvidé mi nombre de usuario",
            to: "/account/forgot",
            bottom: false,
            menu: true,
            toolbar: false,
          },
        ],
        text: localization ? "Account" : "Cuenta",
        to: "/",
        bottom: false,
        menu: true,
        toolbar: false,
      },
      {
        id: "setting",
        cy: "setting",
        breakpoint: 5,
        icon: "mdi-cog",
        text: "Settings",
        to: "/",
        rules: [ Roles.administrator, Roles.manager ],
        bottom: false,
        menu: true,
        toolbar: false,
        subItems: [
          {
            id: "setting.estimates",
            cy: "setting.estimages",
            icon: "mdi-view-list",
            loggedIn: true,
            text: "Estimates",
            subItems: [],
            to: "/setting/estimate",
            rules: [ Roles.administrator, Roles.manager ],
            bottom: false,
            menu: true,
            toolbar: false,
          },
          {
            id: "setting.logs",
            cy: "setting.logs",
            icon: "mdi-view-list",
            loggedIn: true,
            text: "Logs",
            subItems: [],
            to: "/setting/log",
            rules: [ Roles.administrator ],
            bottom: false,
            menu: true,
            toolbar: false,
          },
        ]
      },
      {
        id: "contact",
        cy: 'contact-menu',
        breakpoint: 2,
        icon: "mdi-email",
        rules: [],
        subItems: [],
        text: localization ? "Contact" : "Contacta",
        to: "/contact",
        bottom: true,
        menu: true,
        toolbar: true,
      },
    ];

    return menuItems;
  },

  get(loadingOn) {
    const user = store.getters.getUser;
    const menuItems = this.load();
    let items = [];
    menuItems.forEach((item) => {
      if (this.passesRules(item, user, loadingOn)) {
        let subs = [];
        item.subItems.forEach((subItem) => {
          if (this.passesRules(subItem, user, loadingOn)) {
            subs.push(subItem);
          }
        });
        item.subItems = subs;
        items.push(item);
      }
    });

    // console.log(loadingOn, ".menuItems:", items);
    return items;
  },

  passesRules(item, user, loadingOn) {
    let passed = false;
    if(item.rules.length == 0) {
      passed = true;
    } else {
      item.rules.forEach(rule => {
        switch (rule) {
          case "":
            passed = true;
            break;
          case Account.loggedIn:
            passed = user.isVerified;
            break;
          case Account.loggedOut:
            passed = !user.isVerified;
            break;

          case Roles.administrator:
            var isAdmin = user.userRoles.indexOf(Roles.administrator) > -1;
            passed = user.isVerified && isAdmin;
            break;
        }
      })
    }

    // If passed check what item is being loaded on
    if(passed) {
      switch (loadingOn) {
        case Loader.bottom:
          passed = item.bottom;
          break;
        case Loader.menu:
          passed = item.menu;
          break;
        case Loader.toolbar:
          passed = item.toolbar;
          break;

        default:
          passed = false;
          break;
      }
    }

    return passed;
  },
};
